import { render, staticRenderFns } from "./SearchLayout.vue?vue&type=template&id=313ce431&scoped=true"
import script from "./SearchLayout.vue?vue&type=script&lang=ts"
export * from "./SearchLayout.vue?vue&type=script&lang=ts"
import style0 from "./SearchLayout.vue?vue&type=style&index=0&id=313ce431&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ce431",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313ce431')) {
      api.createRecord('313ce431', component.options)
    } else {
      api.reload('313ce431', component.options)
    }
    module.hot.accept("./SearchLayout.vue?vue&type=template&id=313ce431&scoped=true", function () {
      api.rerender('313ce431', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/SearchLayout.vue"
export default component.exports